import React from "react";
import "../css/Trainers.css";

const Trainers = () => {
  return (
    <div className="trainers6">

      {/* ================= HERO ================= */}
      <section className="t6-hero">
        <h1>Our Trainers</h1>
        <p>Guidance. Experience. Presence.</p>
      </section>

      {/* ================= TRAINER LIST ================= */}
      <section className="t6-list">

        <div className="trainer-row">
          <div className="trainer-img">
            <img src="https://images.pexels.com/photos/6453399/pexels-photo-6453399.jpeg" alt="trainer" />
          </div>
          <div className="trainer-info">
            <h2>Alex Monroe</h2>
            <span>Strength & Conditioning</span>
            <p>
              Focused on foundational strength, posture, and controlled power.
              Alex brings precision-driven coaching with calm intensity.
            </p>
          </div>
        </div>

        <div className="trainer-row reverse">
          <div className="trainer-img">
            <img src="https://images.pexels.com/photos/3823039/pexels-photo-3823039.jpeg" alt="trainer" />
          </div>
          <div className="trainer-info">
            <h2>Sophia Reed</h2>
            <span>Mobility & Recovery</span>
            <p>
              Sophia blends mobility, breathwork, and recovery-based movement
              for long-term joint health and balance.
            </p>
          </div>
        </div>

        <div className="trainer-row">
          <div className="trainer-img">
            <img src="https://images.pexels.com/photos/3757376/pexels-photo-3757376.jpeg" alt="trainer" />
          </div>
          <div className="trainer-info">
            <h2>Marcus Lee</h2>
            <span>Performance Training</span>
            <p>
              Performance-driven programming built for resilience, endurance,
              and sustainable athletic output.
            </p>
          </div>
        </div>

      </section>

    </div>
  );
};

export default Trainers;
